import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e?.preventDefault();
    // Form submission logic would go here
    alert('Gracias por tu interés. Nos pondremos en contacto contigo pronto.');
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e?.target?.name]: e?.target?.value
    });
  };

  return (
    <section id="contact" className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - Info */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              ¿Listo para comenzar?
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Solicita acceso a la plataforma o contáctanos para más información sobre nuestros servicios.
            </p>

            {/* Contact Info */}
            <div className="space-y-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg flex-shrink-0">
                  <Icon name="Mail" size={20} className="text-primary" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground mb-1">Email</div>
                  <div className="text-sm text-muted-foreground">contacto@vinpro.mx</div>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg flex-shrink-0">
                  <Icon name="Phone" size={20} className="text-primary" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground mb-1">Teléfono</div>
                  <div className="text-sm text-muted-foreground">+52 (55) 1234-5678</div>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg flex-shrink-0">
                  <Icon name="MapPin" size={20} className="text-primary" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground mb-1">Ubicación</div>
                  <div className="text-sm text-muted-foreground">Ciudad de México, México</div>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg flex-shrink-0">
                  <Icon name="Clock" size={20} className="text-primary" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground mb-1">Horario</div>
                  <div className="text-sm text-muted-foreground">Lunes a Viernes: 9:00 - 18:00</div>
                  <div className="text-sm text-muted-foreground">Soporte 24/7 disponible</div>
                </div>
              </div>
            </div>

            {/* CTA for Existing Users */}
            <div className="bg-primary/5 border border-primary/20 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-foreground mb-2">
                ¿Ya tienes una cuenta?
              </h3>
              <p className="text-sm text-muted-foreground mb-4">
                Accede a tu panel de control y comienza a realizar consultas de VIN.
              </p>
              <Link to="/login-and-authentication">
                <Button variant="default" size="default" iconName="LogIn" fullWidth>
                  Iniciar Sesión
                </Button>
              </Link>
            </div>
          </div>

          {/* Right Column - Form */}
          <div className="bg-card border border-border rounded-lg p-8 shadow-elevation">
            <h3 className="text-2xl font-bold text-foreground mb-6">
              Solicitar Información
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Nombre Completo *
                </label>
                <Input
                  type="text"
                  name="name"
                  value={formData?.name}
                  onChange={handleChange}
                  placeholder="Tu nombre"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Email Corporativo *
                </label>
                <Input
                  type="email"
                  name="email"
                  value={formData?.email}
                  onChange={handleChange}
                  placeholder="tu@empresa.com"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Empresa *
                </label>
                <Input
                  type="text"
                  name="company"
                  value={formData?.company}
                  onChange={handleChange}
                  placeholder="Nombre de tu empresa"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Teléfono
                </label>
                <Input
                  type="tel"
                  name="phone"
                  value={formData?.phone}
                  onChange={handleChange}
                  placeholder="+52 (55) 1234-5678"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Mensaje
                </label>
                <textarea
                  name="message"
                  value={formData?.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-3 py-2 bg-input border border-border rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 transition-smooth"
                  placeholder="Cuéntanos sobre tus necesidades..."
                />
              </div>

              <Button type="submit" variant="default" size="lg" iconName="Send" fullWidth>
                Enviar Solicitud
              </Button>

              <p className="text-xs text-muted-foreground text-center mt-4">
                Al enviar este formulario, aceptas nuestra política de privacidad y términos de servicio.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;